import { InstructionModal } from '@/components/screens/InstructionModal'
import { useInterviewSessionContext } from '@/context/InterviewSessionContext'
import {useInterviewStore} from "@/store/interviewStore.ts";
import {useNavigate} from "react-router-dom";
import {useEffect} from "react";

export function InstructionsScreen() {
  const { language, handleContinue, handleBackToAvatar } = useInterviewSessionContext()
  const store = useInterviewStore()
  const navigate = useNavigate()

  useEffect(() => {
    if (!store.config) {
      navigate('/', { replace: true })
    }
  }, [store.config, navigate])
  return <InstructionModal language={language} onContinue={handleContinue} onBack={handleBackToAvatar} />
}
